import React from 'react';
import { IconButton, mergeStyles } from '@fluentui/react';


const defaultMenus = [
  {
    key: 'Active',
    text: _TL_('Enabled'),
    color: '#107C10',
    className: 'statis-enabled',
    icon: 'StatusCircleInner',
  },
  {
    key: 'Paused',
    text: _TL_('Paused'),
    color: '#323130',
    className: 'statis-paused',
    icon: 'Pause',
  },
];


const selectedStyle = {
  '.ms-ContextualMenu-itemText': {
    fontWeight: 'bold',
  },
};

const buttonStyle = color => ({
  height: 'auto',
  '.ms-Button-icon': {
    fontSize: 12,
    color,
  },
  '&:hover': {
    background: 'transparent',
    color: 'inherit',
  },
});

const iconStyle = color => ({
  '.ms-ContextualMenu-icon': {
    fontSize: 12,
    color,
  },
});

export const ColumnStatusIcon = ({
  i18n, readOnly = false, menus = defaultMenus, onEditStatus = () => {},
}) => ({
  key: 'Status',
  name: i18n.getString(_TL_('Status')),
  fieldName: 'Status',
  className: 'column-status',
  headerClassName: 'header-status',
  minWidth: 35,
  maxWidth: 35,
  sortable: true,
  isResizable: false,
  onRenderHeader: () => (
    <div />
  ),
  onRender: (item) => {
    const { Status } = item;
    const selectedItem = menus.find(menu => menu.key === Status);
    return (
      (
        <IconButton
          className={`${mergeStyles(buttonStyle(selectedItem.color))} ${selectedItem.className}`}
          title={i18n.getString(selectedItem.text || '')}
          ariaLabel={i18n.getString(selectedItem.text || '')}
          disabled={readOnly}
          iconProps={{ iconName: selectedItem.icon }}
          menuProps={{
            className: 'status-menu',
            items: menus.map(menu => ({
              key: menu.key,
              text: i18n.getString(menu.text),
              className: `${menu.className} ${mergeStyles(iconStyle(menu.color))} ${Status === menu.key && mergeStyles(selectedStyle)}`,
              iconProps: { iconName: menu.icon },
              onClick: () => onEditStatus(menu.key, item),
            })),
          }}
        />
      )
    );
  },
});
